// Standard SM-2 spaced-repetition algorithm. Field names (easeFactor, interval,
// repetitions, dueDate, lastReviewed) intentionally match Sources/FlowNote/Models/
// MemoryState.swift byte-for-byte so a card's schedule round-trips correctly
// through Firestore between the Mac app and mobile-web.
//
// state shape: { easeFactor, interval, repetitions, dueDate, lastReviewed } | null
// grade: 'again' | 'hard' | 'good' | 'easy'

const GRADE_QUALITY = { again: 0, hard: 3, good: 4, easy: 5 };
const DAY_MS = 24 * 60 * 60 * 1000;

export function scheduleNext(state, grade) {
  let { easeFactor = 2.5, interval = 0, repetitions = 0 } = state || {};
  const q = GRADE_QUALITY[grade] ?? GRADE_QUALITY.good;

  if (q < 3) {
    repetitions = 0;
    interval = 1;
  } else {
    repetitions += 1;
    if (repetitions === 1) interval = 1;
    else if (repetitions === 2) interval = 6;
    else interval = Math.round(interval * easeFactor);
  }

  easeFactor = Math.max(1.3, easeFactor + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02)));

  const now = new Date();
  return {
    easeFactor,
    interval,
    repetitions,
    dueDate: new Date(now.getTime() + interval * DAY_MS).toISOString(),
    lastReviewed: now.toISOString()
  };
}

export function isDue(state) {
  if (!state || !state.dueDate) return true; // never scheduled — due immediately
  return new Date(state.dueDate).getTime() <= Date.now();
}

export function runSelfCheck() {
  let state = null;
  state = scheduleNext(state, 'good'); // repetitions=1, interval=1
  console.assert(state.repetitions === 1 && state.interval === 1, '[sm2] first good rep should be interval=1');
  state = scheduleNext(state, 'good'); // repetitions=2, interval=6
  console.assert(state.repetitions === 2 && state.interval === 6, '[sm2] second good rep should be interval=6');
  const before = state.easeFactor;
  state = scheduleNext(state, 'again'); // lapse resets repetitions/interval, drops ease
  console.assert(state.repetitions === 0 && state.interval === 1 && state.easeFactor < before, '[sm2] lapse should reset reps/interval and lower ease');
  console.assert(isDue(null) === true, '[sm2] unscheduled card should be due');
  console.assert(isDue({ dueDate: new Date(Date.now() + DAY_MS).toISOString() }) === false, '[sm2] future due date should not be due yet');
}
